// src/components/TimelineEntryPoint.js
// Ponto de entrada da Timeline dentro do ProfilePage:
// - Renderiza o botão flutuante "TIMELINE" no canto inferior direito
// - Abre o TimelineModal
// - Controla a abertura do PostarModal e ReplyModal a partir do TimelineModal
//
// Como usar no ProfilePage:
// <TimelineEntryPoint
//   usuarioDoc={usuarioDoc}                 // doc de usuarios/{uid} (nome, sobrenome, fotoPerfil, especialista, ...)
//   snapByModo={snapDropdown?.dados || {}}  // objeto com modos/categorias que o usuário tem
// />
//
// Observações:
// - Este componente *não* faz leituras ao montar. A primeira leitura do feed ocorre
//   dentro do TimelineModal *apenas* quando ele é aberto (conforme especificação).

import React, { useMemo, useState } from "react";
import TimelineModal from "./TimelineModal";
import PostarModal from "./PostarModal";
import ReplyModal from "./ReplyModal";

// Ícone do botão flutuante (o seu)
const ICON_TIMELINE = "https://i.imgur.com/zhvk1oW.png";

// Botão flutuante estilizado inline para não colidir com seu CSS existente
const btnStyle = {
  position: "fixed",
  right: "16px",
  bottom: "16px",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  gap: "10px",
  background: "#1f1f1f",
  color: "#ffffff",
  border: "0",
  borderRadius: "999px",
  padding: "12px 16px",
  boxShadow: "0 14px 34px rgba(0,0,0,0.35)",
  cursor: "pointer",
  fontWeight: 900,
  letterSpacing: "0.3px",
};

const iconStyle = { width: 22, height: 22 };

export default function TimelineEntryPoint({ usuarioDoc, snapByModo = {} }) {
  const [openTimeline, setOpenTimeline] = useState(false);
  const [openPostar, setOpenPostar] = useState(false);
  const [openReply, setOpenReply] = useState(false);
  const [replyPost, setReplyPost] = useState(null);

  // Mapeia currentUser para o formato usado pelos modais/serviço
  const currentUser = useMemo(() => {
    if (!usuarioDoc) return null;
    const nome = `${usuarioDoc?.nome || ""}`.trim();
    const sobrenome = `${usuarioDoc?.sobrenome || ""}`.trim();
    return {
      uid: usuarioDoc.uid || usuarioDoc.id || usuarioDoc?.__id, // caso você tenha salvo o id
      name: [nome, sobrenome].filter(Boolean).join(" "),
      avatar: usuarioDoc.fotoPerfil || "",
      especialista: !!usuarioDoc.especialista,
    };
  }, [usuarioDoc]);

  // Handlers que o TimelineModal vai chamar
  function handleOpenPostar(payload) {
    // payload opcional: { editPost } ou { deletePost }
    setOpenPostar(true);
  }

  function handleOpenReply(post) {
    setReplyPost(post);
    setOpenReply(true);
  }
  

  return (
    <>
      {/* Botão flutuante no ProfilePage */}
      
<button
  className="timeline-fab"
  type="button"
  onClick={() => setOpenTimeline(true)}
  title="Abrir Timeline"
>
    <span className="timeline-fab-pill">TIMELINE</span>  
  <span className="timeline-fab-circle" aria-hidden="true">
    <img src="https://i.imgur.com/zhvk1oW.png" alt="" />
  </span>

</button>

      {/* Modal principal: Timeline */}
      {openTimeline && (
        <TimelineModal
          currentUid={currentUser?.uid}
          onClose={() => setOpenTimeline(false)}
          onOpenPost={handleOpenPostar}
          onOpenReply={handleOpenReply}
        />
      )}

      {/* Modal: Postar */}
      {openPostar && currentUser && (
        <PostarModal
          currentUser={currentUser}
          snapByModo={snapByModo || {}}
          onClose={() => setOpenPostar(false)}
          onDone={() => {
            // após publicar, podemos manter a timeline aberta; ela já está por baixo
            setOpenPostar(false);
          }}
        />
      )}

      {/* Modal: Reply */}
      {openReply && currentUser && replyPost && (
        <ReplyModal
          post={replyPost}
          currentUid={currentUser.uid}
          currentUser={currentUser}
          onClose={() => setOpenReply(false)}
          onCloseTimeline={() => {
            setOpenReply(false);
            setOpenTimeline(false);
          }}
          onAfterReply={() => {
            // opcional: aqui poderíamos sinalizar para a timeline atualizar contadores
          }}
        />
      )}
    </>
  );
}
